import React from 'react';
import style from './style.module.css';

interface PageHeaderProps {
  subtitle: string;
  title: string;
  bgColor: 'light' | 'dark';
}

const PageHeader = React.memo(
  ({ subtitle, title, bgColor = 'light' }: PageHeaderProps) => (
    <div className={`${style[bgColor]} ${style.containerPageHeader}`}>
      <div className={style.contentPageHeader}>
        <h4 className={style.subtitlePageHeader}>{subtitle}</h4>
        <h1 className={style.titlePageHeader}>{title}</h1>
      </div>
    </div>
  )
);

PageHeader.displayName = 'PageHeader';

export default PageHeader;
